export const E2E_ROUTE_NAMES = {
  PAGE: 'CMS_E2E_PAGE',
}
